import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';
import { CONSTANTS } from 'src/app/core/config/constants';

@Injectable({
  providedIn: 'root'
})
export class PusherService {
  pusher:any;
  public pusherClient:Pusher;
  constructor() {
    this.pusherClient = new Pusher(CONSTANTS.APP.PUSHER_CLIENT_KEY,
       { cluster: CONSTANTS.APP.PUSHER_CLIENT_CLUSTER });
  }

  unsubscribePusher(channelName:any){
    this.pusherClient.unsubscribe(channelName);
  }

 
}
